import { EditButton, useModalForm } from '@refinedev/antd';
import { CrudFilters } from '@refinedev/core';
import { Tabs, Modal, Button } from 'antd';
import Cw8Create from 'components/cw8/Cw8Create';
import Cw8Edit from 'components/cw8/Cw8Edit';
import Cw8List from 'components/cw8/Cw8List';
import { ConfigCard } from 'interfaces/schemaDB';

const configCard: ConfigCard = {
    fieldTitle: "frs_title",
    fieldDesc: ""
}

interface EditSubSectionPublicationProps {
    idSubsection?: string,
    idSection?: string,
    // isOpenModal: boolean;
    // setOpenModal: (newState: boolean) => void;
}

export const EditComponentsPublication = ({ idSubsection, idSection
    // , isOpenModal, setOpenModal 
}: EditSubSectionPublicationProps) => {




    // const {
    //     modalProps: createModalProps,
    //     formProps: createFormProps,
    //     show: createModalShow
    // } = useModalForm({ action: "create", resource: 'subsectionPub', redirect: false });


    const {
        // close : closeModal,
        modalProps: editModalProps,
        formProps: editFormProps,
        show: editModalShow,
        // modal: { visible, close, show }
    } = useModalForm({
        // } = useModal({
        action: "edit"
        , resource: 'subsectionPub'
        , redirect: false
        // , warnWhenUnsavedChanges: true
        // , autoResetForm : true 
    });


    const filterList: CrudFilters = [
        {
            field: "sup_id_section",
            operator: "eq",
            value: idSection
        },
    ]

    //   const handleCancel = () => {
    //     setOpenModal(false);
    //   };

    if (!idSubsection) {
        return (<h3>Seleccione una subSección</h3>)
    }



    const extraContent = (
        <div>
            {/* <a href={`${config.urlAPI}/publicar/publication/${id}`} target="_blank" rel="noreferrer" style={{marginRight: 5}}> */}
            <Button 
                onClick={ ()=> editModalShow(idSubsection)}
            >Editar Subsección</Button>

            {/* <EditButton size="small"
                recordItemId={idSubsection}
                resource="subsectionPub"
            /> */}
            {/* </a> */}
            {/* <a href={`${config.urlSitelibros}libros/${id}`} target="_blank" rel="noreferrer"> */}
            {/* <Button>Ver libro</Button> */}
            {/* </a> */}
        </div>
    );

    return (
        <>
            <Tabs defaultActiveKey="0"
                tabBarExtraContent={extraContent}
                items={[
                    {
                        label: 'Fragmentos',
                        key: '1',
                        children: (
                            <Cw8List
                                resourceName={'fragmentPub'}
                                filterList={[
                                    {
                                        field: "frs_id_subsection",
                                        operator: "eq",
                                        value: idSubsection
                                    }
                                ]}
                                titleList={`Fragmentos`}
                                showCards={true}
                                createModal={true}
                                editModal={true}
                                configCard={configCard}
                            />)
                    },
                    // {
                    //     label: 'SubSecciones',
                    //     key: '2',
                    //     children: (<Cw8List
                    //         resourceName = {'subsectionPub'}
                    //         filterList ={[
                    //             {
                    //                 field: "sup_id_section",
                    //                 operator: "eq",
                    //                 value: idSection
                    //             }
                    //         ]}
                    //         titleList = {"SubSección"}
                    //         showCards = {true}
                    //         createModal = {true}
                    //         editModal = {true}            
                    //         configCard = {{
                    //             fieldTitle : "sup_title",
                    //         }}                    
                    //     />)
                    // },
                    // {
                    //     label: `Editar Sección`,
                    //     key: '3',
                    //     children: (<Cw8Edit
                    //         resourceName = {'sectionPub'}
                    //         id={idSection}

                    //     />)
                    // },
                    // {
                    //     label: 'Editar sub Sección',
                    //     key: '4',
                    //     children: (<Cw8Edit
                    //         resourceName = {'subsectionPub'}
                    //         id={idSubsection}
                    //         modal = {false}
                    //     />)
                    // }
            ]}></Tabs>
            

            <Modal {...editModalProps}
                // open={true} 
                // onCancel={ ()=> setOpenCreateModal(false) } 
                // key={idSection} 
                // destroyOnClose={true}
                // width={1000}
                // footer={[
                // ]}        
                title="Editar Subsección"
            >

                <Cw8Edit
                    key={idSection}
                    resourceName={'subsectionPub'}
                    editFormProps={editFormProps}
                    idResource={idSubsection}
                    modal={true}
                // closeModal={cerrarModal}
                ></Cw8Edit>

            </Modal>
            


        </>
    )
}